import React from 'react';
import { Header } from 'semantic-ui-react';
import { parse, format } from 'date-fns';
import _isNaN from 'lodash/isNaN';
import _startCase from 'lodash/startCase';
var defaultProps = {
  startTime: null,
  endTime: null,
  availableDays: []
};
var ScheduleAvailability = function ScheduleAvailability(_ref) {
  var _ref$availableDays = _ref.availableDays,
    availableDays = _ref$availableDays === void 0 ? [] : _ref$availableDays,
    startTime = _ref.startTime,
    endTime = _ref.endTime;
  if (!availableDays) {
    return null;
  }
  var alwaysAvailable = availableDays.length === 1 && availableDays[0] === 'ALL';
  if (alwaysAvailable) return /*#__PURE__*/React.createElement("div", null);
  var startTimeDate = parse(startTime, 'HH:mm:ss', new Date());
  var endTimeDate = parse(endTime, 'HH:mm:ss', new Date());
  var hoursAreDefined = !_isNaN(startTimeDate.getTime()) && !_isNaN(endTimeDate.getTime());
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '2rem',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Header, {
    as: "h5",
    style: {
      marginBottom: 0
    }
  }, "Available On:"), /*#__PURE__*/React.createElement(Header, {
    as: "h6"
  }, availableDays.map(function (day, index) {
    return /*#__PURE__*/React.createElement("span", {
      key: day
    }, _startCase(day.toLowerCase()), index === availableDays.length - 1 ? '' : ', ');
  }), hoursAreDefined && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, " from "), /*#__PURE__*/React.createElement("span", null, format(startTimeDate, 'h:mm aaa')), /*#__PURE__*/React.createElement("span", null, " to "), /*#__PURE__*/React.createElement("span", null, format(endTimeDate, 'h:mm aaa')))));
};
ScheduleAvailability.defaultProps = defaultProps;
export default ScheduleAvailability;